import { render, staticRenderFns } from "./kdniaoConfig.vue?vue&type=template&id=5f598f87&scoped=true"
import script from "./kdniaoConfig.vue?vue&type=script&lang=js"
export * from "./kdniaoConfig.vue?vue&type=script&lang=js"
import style0 from "./kdniaoConfig.vue?vue&type=style&index=0&id=5f598f87&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f598f87",
  null
  
)

component.options.__file = "kdniaoConfig.vue"
export default component.exports